<template>
    <div class="h-100 d-flex align-items-center px-2">
        <AppButton v-if="showViewAssetsAction"
                   v-tooltip="'View uploads'"
                   circle text
                   @click="viewUploads"
                   class="mr-2">
            <i class="fal fa-file"></i>
        </AppButton>
        <AppButton @click="openDocument" circle text v-tooltip="'Open document'" class="mr-2">
            <i class="fal fa-external-link"></i>
        </AppButton>
        <AppButton @click="deleteRelatedDoc" circle text>
            <span v-show="isRemoving">
                <i class="fas fa-spinner fa-spin"></i>
            </span>
            <span v-show="!isRemoving" class="text-danger clickable">
                <i class="fal fa-trash-alt"></i>
            </span>
        </AppButton>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import {mapGetters, mapMutations} from 'vuex'
import {openDocumentViewer} from '../../../../index'
import {convertDocumentSectionForDocumentsAPI} from '@/types/document/types'
import {DOCS_BACK_STACK_PUSH} from '@/store/modules/documents'
import EventBus from '@/command/bus'
import AppButton from '@/components/buttons/AppButton.vue'

export default Vue.extend({
    name: 'AgGridCellRendererActions',
    components: {AppButton},
    data() {
        return {
            isRemoving: false
        }
    },
    computed: {
        ...mapGetters('doc_viewer', [
            'doc'
        ]),

        relatedDoc() {
            return this.params.data || {}
        },

        showViewAssetsAction() {
            return !!this.params.showViewAssetsAction
        }
    },
    methods: {
        ...mapMutations('documents', {
            docsBackStackPush: DOCS_BACK_STACK_PUSH
        }),

        openDocument() {
            this.docsBackStackPush(this.doc)
            openDocumentViewer({id: this.relatedDoc.uuid})
        },

        viewUploads() {
            EventBus.$emit('SHOW_RELATED_DOC_UPLOADS', this.relatedDoc)
        },

        deleteRelatedDoc() {
            this.isRemoving = true
            axios.delete('documents/relates', {
                data: {
                    fromType: convertDocumentSectionForDocumentsAPI(this.doc.section),
                    fromUUID: this.doc.uuid,
                    toType: convertDocumentSectionForDocumentsAPI(this.relatedDoc.section),
                    toUUID: this.relatedDoc.uuid
                }
            }).then(() => {
                this.$bus.$emit('DELETED_RELATED_DOCUMENT')
            }).catch(error => {
                this.$snackbar.show({error})
            }).finally(() => {
                this.isRemoving = false
            })
        }
    }
})
</script>
